export { ConfigDocumentsComponent } from './config-documents.component';
export * from './types';
